<template>
  <div>
    <div class="row ma-0 mb-4">
      <h1 :style="{ color: $themes.primary, textTransform: 'uppercase' }">{{ title }}</h1>
    </div>

    <va-card class="flex md6 xs12">
      <form @submit.prevent="handleProvider">
        <div class="row">
          <file-upload v-model="provider.photo" :error="!!errorsPhoto.length" :errorMessage="errorsPhoto" />
        </div>
        <!-- INFORMAÇÕES -->
        <div class="row ma-0 justify--space-between">
          <h3 class="form-title" :style="{ color: $themes.primary }">Informações Básicas</h3>
          <va-toggle
            v-model="provider.premium"
            label="Premium"
            small
          />
        </div>
        <div class="row">
          <va-input
            v-model="provider.name"
            label="Nome *"
            :error="!!errorsName.length"
            :error-messages="errorsName"
            class="flex xs12" />
        </div>

        <div class="row align--start">
          <va-input
            type="email"
            v-model="provider.email"
            label="Email"
            :error="!!errorsEmail.length"
            :error-messages="errorsEmail"
            class="flex xs12 md4" />

          <va-input
            @keypress="numberOnly"
            @change="handleTel"
            v-model="provider.phone"
            label="Telefone *"
            maxlength="11"
            :error="!!errorsTel.length"
            :error-messages="errorsTel"
            class="flex xs12 md4" />

          <va-input
            @keypress="numberOnly"
            @change="handleWhats"
            v-model="provider.whatsapp"
            label="Whatsapp"
            maxlength="11"
            :error="!!errorsWhats.length"
            :error-messages="errorsWhats"
            class="flex xs12 md4" />
        </div>

        <!-- SERVIÇOS -->
        <h3 class="form-title" :style="{ color: $themes.primary }">Serviços</h3>
        <div class="row">
          <va-input-wrapper
            :error="!!errorsCategory.length"
            :error-messages="errorsCategory"
            class="flex xs12 md6">
            <va-select
              label="Categoria *"
              v-model="provider.category"
              textBy="name"
              :options="categories"
              :error="!!errorsCategory.length" />
          </va-input-wrapper>

          <va-input-wrapper
            :error="!!errorsServices.length"
            :error-messages="errorsServices"
            class="flex xs12 md6">
            <va-select
              label="Serviços *"
              v-model="provider.service"
              textBy="name"
              multiple
              :options="services"
              :error="!!errorsServices.length" />
          </va-input-wrapper>
        </div>

        <!-- REDES SOCIAIS -->
        <h3 class="form-title" :style="{ color: $themes.primary }">Redes Sociais</h3>
        <div class="row">
          <va-input label="Facebook" v-model="provider.facebook" class="flex xs12 md6">
            <span slot="prepend">https://facebook.com/</span>
          </va-input>

          <va-input label="Instagram" v-model="provider.instagram" class="flex xs12 md6">
            <span slot="prepend">https://instagram.com/</span>
          </va-input>

          <va-input label="Website" v-model="provider.site" class="flex xs12 md6"></va-input>
        </div>

        <!-- ENDEREÇO -->
        <h3 class="form-title" :style="{ color: $themes.primary }">Endereço</h3>
        <div class="row">
          <va-input
            @keypress="numberOnly"
            label="CEP *"
            v-model.number="provider.address.cep"
            @change="handleZip"
            maxlength="8"
            :error="!!errorsZip.length"
            :error-messages="errorsZip"
            class="flex md6 xs12"
          />
        </div>

        <div class="row align--start">
          <va-input
            label="Rua *"
            v-model="provider.address.logradouro"
            maxlength="30"
            :error="!!errorsStreet.length"
            :error-messages="errorsStreet"
            :disabled="!!provider.address.logradouro.length && disableInputs"
            class="flex xs10"
          />

          <va-input
            label="Nº"
            @keypress="numberOnly"
            v-model.number="provider.address.numero"
            maxlength="5"
            class="flex xs2"
          />

        </div>

        <div class="row">
          <va-input
            label="Bairro"
            v-model="provider.address.bairro"
            maxlength="30"
            :disabled="!!provider.address.bairro.length && disableInputs"
            class="flex xs6"
          />

          <va-input
            label="Complemento"
            v-model="provider.address.complemento"
            maxlength="30"
            class="flex xs6"
          />
        </div>

        <div class="row">
          <va-input-wrapper class="flex xs6">
            <va-select
              label="Cidade"
              v-model="provider.address.localidade"
              textBy="nome"
              searchable
              :options="cidades"
              :disabled="true" />
          </va-input-wrapper>

          <va-input-wrapper class="flex xs4">
            <va-select
              label="Estado"
              v-model="provider.address.estado"
              textBy="sigla"
              :options="estados"
              :disabled="true" />
          </va-input-wrapper>
        </div>

        <div class="row ma-0">
          <text-area v-model="provider.description" :error="!!errorsDescription.length" :errorMessage="errorsDescription"></text-area>
        </div>

        <div class="row ma-0">
          <va-button outline color="danger" @click="$router.push({ name: 'providers' })">Voltar</va-button>
          <va-button type="submit">{{ buttonText }}</va-button>
        </div>
      </form>
    </va-card>
  </div>
</template>

<script>
import axios from 'axios'
import api from '../api'

import FileUpload from '../components/FileUpload.vue'
import TextArea from '../components/TextArea.vue'

export default {
  data () {
    return {
      provider: {
        address: {
          bairro: '',
          logradouro: '',
          estado: {},
          localidade: {},
          cidade: '',
          rua: '',
          complemento: '',
        },
        premium: false,
        category: {},
        service: [],
        photo: '',
        description: '',
      },
      cidade: '',
      errorsPhoto: [],
      errorsName: [],
      errorsEmail: [],
      errorsZip: [],
      errorsStreet: [],
      errorsTel: [],
      errorsWhats: [],
      errorsCategory: [],
      errorsServices: [],
      errorsDescription: [],
      disableInputs: false, // disables inputs if filled by api
      isWhatsapp: false,
      categories: [],
      services: [],
    }
  },
  components: {
    FileUpload,
    TextArea,
  },
  computed: {
    title () {
      return this.$route.params.id
        ? 'Editar Prestador de Serviço'
        : 'Novo Prestador de Serviço'
    },

    buttonText () {
      return this.$route.params.id
        ? 'Editar'
        : 'Cadastrar'
    },

    cidades () {
      return this.$store.state.app.cidades
    },

    estados () {
      return this.$store.state.app.estados
    },
  },
  mounted () {
    if (this.$route.params.id) {
      api.get(`/provider/${this.$route.params.id}`)
        .then(prestador => {
          this.provider = prestador.data
          const bairro = this.provider.address.bairro
          const complemento = this.provider.address.complemento

          api.get(`/address/get-address-by-cep/${this.provider.address.cep}`)
            .then(res => {
              if (res.data.erro) {
                this.errorsZip = ['Nenhum endereço encontrado com o CEP ' + this.provider.address.cep]
                return false
              } else {
                this.errorsZip = []
              }
              // this.disableInputs = true
              this.cidade = res.data.localidade
              this.provider.address = { ...this.provider.address, ...res.data }
              this.provider.address.estado = this.estados.find(estado => estado.sigla === res.data.uf)
              this.provider.address.logradouro = prestador.data.address.rua
              this.provider.address.bairro = bairro
              this.provider.address.complemento = complemento

              if (this.provider.facebook) {
                const faceId = this.provider.facebook.split('/')

                this.provider.facebook = faceId[3]
              }

              if (this.provider.instagram) {
                const instaId = this.provider.instagram.split('/')

                this.provider.instagram = instaId[3]
              }
            })
            .catch(err => console.log(err.message))
        })
        .catch(err => console.log(err.message))
    }

    if (this.estados.length) {
      this.provider.address.estado = this.estados.find(estado => estado.sigla === 'SP')

      axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.provider.address.estado.sigla}/municipios`)
        .then(res => {
          this.$store.commit('setCidades', res.data)
        })
        .catch(err => console.log(err.message))
    }

    api.get('/category?size=1000').then(res => {
      this.categories = res.data.content
    })

    api.get('/service?size=1000').then(res => {
      this.services = res.data.content
    })
  },
  methods: {
    handleZip (event) {
      if (event.target.value.length < 8) {
        this.errorsZip = ['CEP inválido']
        return false
      } else {
        this.errorsZip = []
      }

      // HERE GET Address by CEP
      api.get(`/address/get-address-by-cep/${this.provider.address.cep}`)
        .then(res => {
          if (res.data.erro) {
            this.errorsZip = ['Nenhum endereço encontrado com o CEP ' + this.provider.address.cep]
            return false
          } else {
            this.errorsZip = []
          }
          // this.disableInputs = true
          this.cidade = res.data.localidade
          this.provider.address = { ...this.provider.address, ...res.data }
          this.provider.address.estado = this.estados.find(estado => estado.sigla === res.data.uf)
        })
        .catch(err => console.log(err.message))
    },
    handleTel (event) {
      if (event.target.value.length && event.target.value.length < 10) {
        this.errorsTel = ['Telefone inválido']
      } else {
        this.errorsTel = []
        this.provider.phone = this.provider.phone.replace(/^(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3')
      }
    },
    handleWhats (event) {
      if (event.target.value.length && event.target.value.length < 10) {
        this.errorsWhats = ['Telefone inválido']
      } else {
        this.errorsWhats = []
        this.provider.whatsapp = this.provider.whatsapp.replace(/^(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3')
      }
    },
    numberOnly (event) {
      if (!/\d/g.test(event.key)) return event.preventDefault()
    },
    handleProvider () {
      if (this.validate()) {
        this.provider.address.rua = this.provider.address.logradouro
        //this.provider.address.bairro = this.provider.address.bairro
        this.provider.address.cep = this.provider.address.cep.replace('-', '')
        this.provider.address.codIBGE = this.provider.address.ibge
        this.provider.address.uf = this.provider.address.estado.sigla
        this.provider.address.cidade = this.provider.address.localidade

        if (this.provider.facebook && !this.provider.facebook.startsWith('https://facebook.com/')) {
          this.provider.facebook = 'https://facebook.com/' + this.provider.facebook
        }

        if (this.provider.instagram && !this.provider.instagram.startsWith('https://instagram.com/')) {
          this.provider.instagram = 'https://instagram.com/' + this.provider.instagram
        }

        if (this.provider.site && !this.provider.site.startsWith('https://')) {
          this.provider.site = 'https://' + this.provider.site
        }

        console.log(this.provider)

        if (!this.$route.params.id) {
          api.post('/provider', this.provider)
            .then(res => {
              this.showToast('Prestador de serviço adicionado')

              this.$router.push({ name: 'providers' })
            })
            .catch(err => console.log(err))
        } else {
          api.put(`/provider/${this.$route.params.id}`, this.provider)
            .then(res => {
              this.showToast('Prestador atualizado')

              this.$router.push({ name: 'providers' })
            })
            .catch(err => console.log(err.message))
        }
      } else {
        return false
      }
    },
    validate () {
      this.errorsPhoto = this.provider.photo ? [] : ['Escolher uma imagem']
      this.errorsName = this.provider.name ? [] : ['Campo obrigatório']
      this.errorsTel = this.provider.phone ? [] : ['Campo obrigatório']
      //this.errorsEmail = this.provider.email ? [] : ['Campo obrigatório']
      this.errorsCategory = Object.keys(this.provider.category).length ? [] : ['Selecione uma categoria']
      this.errorsServices = this.provider.service.length ? [] : ['Selecione pelo menos um serviço']
      this.errorsZip = this.provider.address.cep ? [] : ['Campo obrigatório']
      this.errorsStreet = this.provider.address.logradouro ? [] : ['Campo obrigatório']
      this.errorsDescription = this.provider.description ? [] : ['Campo obrigatório']

      /* if (!this.provider.photo) {
        this.errorsPhoto = ['Escolher uma imagem']
      }

      if (!this.provider.name) {
        this.errorsName = ['Campo obrigatório']
      }

      if (!this.provider.phone) {
        this.errorsTel = ['Campo obrigatório']
      }

      if (!this.provider.email) {
        this.errorsEmail = ['Campo obrigatório']
      }

      if (!Object.keys(this.provider.category).length) {
        this.errorsCategory = ['Selecione uma categoria']
      }

      if (!this.provider.service.length) {
        this.errorsServices = ['Selecione pelo menos um serviço']
      }

      if (!this.provider.address.cep) {
        this.errorsZip = ['Campo obrigatório']
      }

      if (!this.provider.address.logradouro) {
        this.errorsStreet = ['Campo obrigatório']
      }

      if (!this.provider.description) {
        this.errorsDescription = ['Campo obrigatório']
      } */

      if (
        this.errorsPhoto.length ||
        this.errorsName.length ||
        this.errorsTel.length ||
        this.errorsEmail.length ||
        this.errorsCategory.length ||
        this.errorsServices.length ||
        this.errorsZip.length ||
        this.errorsStreet.length ||
        this.errorsDescription.length
      ) {
        return false
      }

      return true
    },
  },
  // HERE WATCH state changes
  watch: {
    estados: function (newEstados) {
      this.provider.address.estado = this.estados.find(estado => estado.sigla === 'SP')
    },
    /* 'provider.address.estado': function () {
      axios.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.provider.address.estado.sigla}/municipios`)
        .then(res => {
          this.$store.commit('setCidades', res.data)
          if (this.cidade) {
            this.provider.address.localidade = this.cidades.find(cidade => cidade.nome === this.cidade)
          }
        })
        .catch(err => console.log(err.message))
    }, */
    isWhatsapp: function (value) {
      if (value) this.provider.whatsapp = this.provider.phone
    },
  },
}
</script>

<style lang="scss" scoped>
.form-title {
  padding-bottom: 10px;
  text-transform: uppercase;
  margin-bottom: 20px;
}
</style>
